import React from 'react';

interface IconProps {
  color?: string;
  width?: string | number;
  height?: string | number;
  onClick?: () => void;
}

const SearchIcon: React.FC<IconProps> = ({
  color = '#707EAE',
  width = 16,
  height = 18,
  onClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 11 12"
      fill="none"
      onClick={onClick}
    >
      <circle cx="5" cy="5" r="4.3" stroke={color} strokeWidth="1.4" />
      <line x1="10.0101" y1="11" x2="8" y2="8.98995" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  );
};

export default SearchIcon;
